import Admin, { Role, hasRole } from '@/models/Admin'
import Meta from '@/models/Meta'

export default class MetaPolicy {
	viewAny(admin: Admin) {
		return true
	}

	view(admin: Admin, meta: Meta) {
		return true
	}

	create(admin: Admin) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	update(admin: Admin, meta: Meta) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	restore(admin: Admin, meta: Meta) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	delete(admin: Admin, meta: Meta) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	forceDelete(admin: Admin, meta: Meta) {
		return hasRole(admin, Role.ADMIN)
	}

	trash(admin: Admin) {
		return hasRole(admin, Role.ADMIN)
	}
}
